import React, { useState, useEffect } from "react";
import api from "../../api";

const RaffleModal = ({ isOpen, toggle, playerPos, spawnText }) => {
  const [winners, setWinners] = useState([]);
  const [numbers, setNumbers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isOpen) {
      fetchWinners();
      fetchEntries();
    }
  }, [isOpen]);

  const fetchWinners = async () => {
    setLoading(true);
    try {
      const res = await api.get("/v1/raffle/winners", {
        withCredentials: true,
      });
      setWinners(res.data.winners);
    } catch (err) {
      console.error("Failed to fetch winners", err);
    }
  };

  const fetchEntries = async () => {
    try {
      const res = await api.get("/v1/raffle/details", {
        withCredentials: true,
      });
      setNumbers(res.data.users);
    } catch (err) {
      console.error("Failed to fetch raffle entries", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectNumber = async (num) => {
    try {
      await api.post(
        "/v1/raffle/submit",
        { number: num },
        { withCredentials: true },
      );
      
      // Close modal immediately
      toggle();
      
      // Show floating text for successful selection
      spawnText(
        `Number ${num} selected!`,
        playerPos.x,
        playerPos.y - 20,
        "#4CAF50"
      );
      
    } catch (err) {
      const errorMessage = err.response?.data?.detail || "Error selecting number.";
      spawnText(errorMessage, playerPos.x, playerPos.y - 20, "#f44336");
    }
  };

  if (!isOpen) return null;

  return (
    <div 
      className="game-popup-overlay"
      onClick={toggle}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px 10px',
        boxSizing: 'border-box',
        zIndex: 1050
      }}
    >
      <div 
        className="raffle-popup"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '95%',
          maxWidth: 900,
          maxHeight: '95vh',
          background: 'linear-gradient(to bottom, rgba(29, 34, 46, 0.95), rgba(41, 50, 65, 0.95))',
          color: '#fff',
          borderRadius: 12,
          backdropFilter: 'blur(10px)',
          border: '2px solid rgba(255, 255, 255, 0.1)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          margin: '10px'
        }}
      >
        {/* Header */}
        <div style={{
          padding: '12px 16px',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: 'rgba(0, 0, 0, 0.2)',
          flexWrap: 'wrap',
          gap: '8px',
          minHeight: '60px'
        }}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            flex: '1 1 auto',
            minWidth: '200px'
          }}>
            <span style={{ fontSize: '20px' }}>🎟️</span>
            <h3 style={{ 
              margin: 0, 
              fontSize: '18px', 
              fontWeight: 'bold',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}>Daily Raffle</h3>
          </div>
          
          <button
            onClick={toggle}
            style={{
              background: 'rgba(255, 255, 255, 0.1)',
              border: 'none',
              color: '#fff',
              borderRadius: '4px',
              padding: '6px 12px',
              cursor: 'pointer',
              transition: 'all 0.2s',
              fontSize: '14px'
            }}
            onMouseOver={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
            onMouseOut={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.1)'}
          >
            Close
          </button>
        </div>

        {/* Content */}
        <div style={{
          padding: '16px',
          overflowY: 'auto',
          flex: 1
        }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <div className="spinner-border text-light" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p style={{ marginTop: '10px' }}>Loading raffle data...</p>
            </div>
          ) : (
            <>
              <div style={{
                background: 'rgba(0, 0, 0, 0.2)',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '16px'
              }}>
                <h4 style={{ 
                  fontSize: '18px', 
                  marginBottom: '12px',
                  color: '#ffe066',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                Mini Competition!
                </h4>
                <p style={{ fontSize: '14px', lineHeight: '1.5' }}>
                  Pick a number from 1 to 750. You will receive an event if you win. The winners will be chosen at midnight.
                  <br />
                  <strong>Note:</strong> Only use up to two accounts per daily raffle!
                </p>

                <h5 style={{ 
                  fontSize: '16px', 
                  marginTop: '16px',
                  marginBottom: '8px',
                  color: '#ffe066',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                 Prizes
                </h5>
                <ul style={{ 
                  listStyle: 'none', 
                  padding: 0, 
                  margin: 0,
                  fontSize: '14px'
                }}>
                  <li style={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    marginBottom: '8px'
                  }}>
                    <span style={{ marginRight: '8px', fontWeight: 'bold' }}>1st Place:</span>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <img
                        src="/items/coin.png"
                        alt="coin"
                        width="24"
                        style={{ verticalAlign: 'middle', marginRight: '5px' }}
                      />
                      <span style={{ marginRight: '8px' }}>7,500</span>
                      <span style={{ margin: '0 8px' }}>&</span>
                      <img
                        src="/items/money.png"
                        alt="money"
                        width="24"
                        style={{ verticalAlign: 'middle', marginRight: '5px' }}
                      />
                      <span>25,000,000</span>
                    </div>
                  </li>
                  <li style={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    marginBottom: '8px'
                  }}>
                    <span style={{ marginRight: '8px', fontWeight: 'bold' }}>2nd Place:</span>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <img
                        src="/items/coin.png"
                        alt="coin"
                        width="24"
                        style={{ verticalAlign: 'middle', marginRight: '5px' }}
                      />
                      <span style={{ marginRight: '8px' }}>5,000</span>
                      <span style={{ margin: '0 8px' }}>&</span>
                      <img
                        src="/items/money.png"
                        alt="money"
                        width="24"
                        style={{ verticalAlign: 'middle', marginRight: '5px' }}
                      />
                      <span>15,000,000</span>
                    </div>
                  </li>
                  <li style={{ 
                    display: 'flex', 
                    alignItems: 'center'
                  }}>
                    <span style={{ marginRight: '8px', fontWeight: 'bold' }}>3rd Place:</span>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <img
                        src="/items/coin.png"
                        alt="coin"
                        width="24"
                        style={{ verticalAlign: 'middle', marginRight: '5px' }}
                      />
                      <span style={{ marginRight: '8px' }}>2,500</span>
                      <span style={{ margin: '0 8px' }}>&</span>
                      <img
                        src="/items/money.png"
                        alt="money"
                        width="24"
                        style={{ verticalAlign: 'middle', marginRight: '5px' }}
                      />
                      <span>10,000,000</span>
                    </div>
                  </li>
                </ul>
              </div>

              {/* Yesterday's Winners */}
              <div style={{
                background: 'rgba(0, 0, 0, 0.2)',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '16px'
              }}>
                <h5 style={{ 
                  fontSize: '16px', 
                  marginBottom: '16px',
                  color: '#ffe066'
                }}>
                  Yesterday's Winners
                </h5>
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-around',
                  flexWrap: 'wrap',
                  gap: '16px'
                }}>
                  {winners.length > 0 ? winners.map((winner, idx) => (
                    <div key={idx} style={{ textAlign: 'center' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {idx + 1}{idx === 0 ? 'st' : idx === 1 ? 'nd' : 'rd'}:
                      </div>
                      <a href={`/playerprofile?user=${winner.username}`} style={{ textDecoration: 'none' }}>
                        <img
                          src={`/avatars/${winner.avatar}.png`}
                          alt={winner.username}
                          width="60"
                          height="60"
                          style={{ 
                            borderRadius: '50%',
                            border: '2px solid #ffe066',
                            boxShadow: '0 0 10px rgba(255, 224, 102, 0.5)'
                          }}
                        />
                        <div style={{ color: 'white', marginTop: '4px' }}>{winner.username}</div>
                      </a>
                    </div>
                  )) : (
                    <div style={{ textAlign: 'center', padding: '10px', width: '100%' }}>
                      No winners from yesterday
                    </div>
                  )}
                </div>
              </div>

              {/* Pick Your Number */}
              <div style={{
                background: 'rgba(0, 0, 0, 0.2)',
                borderRadius: '8px',
                padding: '16px'
              }}>
                <h5 style={{ 
                  fontSize: '16px', 
                  marginBottom: '16px',
                  color: '#ffe066',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                     Pick Your Number
                </h5>
                <div style={{ 
                  maxHeight: '300px', 
                  overflowY: 'auto',
                  background: 'rgba(0, 0, 0, 0.3)',
                  borderRadius: '4px',
                  padding: '8px'
                }}>
                  <table style={{ 
                    width: '100%', 
                    borderCollapse: 'collapse',
                    fontSize: '14px'
                  }}>
                    <thead>
                      <tr>
                        <th style={{ 
                          padding: '8px', 
                          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                          textAlign: 'center'
                        }}>Number</th>
                        <th style={{ 
                          padding: '8px', 
                          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                          textAlign: 'center'
                        }}>Chosen By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {numbers.map((entry) => (
                        <tr key={entry.number} style={{ 
                          borderBottom: '1px solid rgba(255, 255, 255, 0.05)'
                        }}>
                          <td style={{ 
                            padding: '8px', 
                            textAlign: 'center'
                          }}>{entry.number}</td>
                          <td style={{ 
                            padding: '8px',
                            textAlign: 'center'
                          }}>
                            {entry.userid ? (
                              <a
                                href={`/playerprofile?user=${entry.username}`}
                                style={{ 
                                  color: 'white',
                                  textDecoration: 'none',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  gap: '8px'
                                }}
                              >
                                <img
                                  src={`/avatars/${entry.avatar}.png`}
                                  alt={entry.username}
                                  width="32"
                                  height="32"
                                  style={{ borderRadius: '50%' }}
                                />
                                <span>{entry.username}</span>
                              </a>
                            ) : (
                              <button
                                onClick={() => handleSelectNumber(entry.number)}
                                style={{
                                  background: 'linear-gradient(to bottom, #4a5568, #2d3748)',
                                  border: 'none',
                                  color: '#fff',
                                  borderRadius: '4px',
                                  padding: '6px 12px',
                                  cursor: 'pointer',
                                  transition: 'all 0.2s',
                                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                                  fontSize: '14px'
                                }}
                                onMouseOver={(e) => {
                                  e.target.style.background = 'linear-gradient(to bottom, #5a6978, #3d4758)';
                                  e.target.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.3)';
                                }}
                                onMouseOut={(e) => {
                                  e.target.style.background = 'linear-gradient(to bottom, #4a5568, #2d3748)';
                                  e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.2)';
                                }}
                              >
                                Select
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default RaffleModal;
